module.exports = __webpack_public_path__ + "media/images/Tiled-Wall-2b-d3dd27af6039ea8985dfd8526ca36a34.png";